import React, { useMemo } from 'react';
import { useUserClients } from '../../../../../contexts/UserClientsContext';
import Select from '../../../../../ui/DataEntry/Select/Select';
import { GenericDropdownOption } from '../../../../../App.types';
import { StylesConfig } from 'react-select';
import styles from './ClientSelect.module.css';
import { useLocation } from 'react-router-dom';
import { useCheckUserGroupsAccess } from '../../../../Auth/hooks/useCheckUserGroupsAccess';

const selectStyles: StylesConfig = {
    control: (provided, state) => ({
        ...provided,
        width: '10rem',
        height: '2rem',
        borderBottom: '1px solid #70f2ee',
        borderRight: '1px solid #70f2ee',
        backgroundColor: 'transparent',
        '&:hover': {
            borderColor: '#70f2ee !important',
            boxShadow: '1px 1px 0 #70f2ee !important',
        },
        ...(state.isFocused && {
            borderColor: '#70f2ee !important',
            boxShadow: '1px 1px 1px #70f2ee !important',
        }),
    }),
    input: (provided) => ({
        ...provided,
        fontSize: '0.75rem',
        lineHeight: '1rem',
        color: '#ffffff',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '0 0.5rem',
    }),
    singleValue: (provided) => ({
        ...provided,
        fontSize: '0.75rem',
        lineHeight: '1rem',
        color: '#ffffff',
    }),
    option: (provided, state) => ({
        ...provided,
        background: state.isSelected ? '#EEEEEE' : state.isFocused ? '#F5F6F8' : 'white',
        color: '#333333',
        ':hover': {
            background: state.isSelected ? '#EEEEEE' : '#F5F6F8',
        },
    }),
};

const ClientSelect = () => {
    const { clients, selectedClient, selectClient } = useUserClients();
    const location = useLocation();

    const userHasClientsAccess = useCheckUserGroupsAccess(['trnds_admin', 'trnds_client'], 'any');

    const displayClientSelect = userHasClientsAccess && clients.length > 1 && location.pathname.includes('/client/');

    const options: GenericDropdownOption<number>[] = clients.map((client) => ({
        label: client.name,
        value: client.id,
    }));

    const selectedClientOption = useMemo(
        () => (selectedClient ? { label: selectedClient.name, value: selectedClient.id } : null),
        [selectedClient]
    );

    return displayClientSelect ? (
        <div className={styles.container}>
            <span>Client:</span>
            <Select
                options={options}
                value={selectedClientOption}
                onChange={(option) => {
                    if (!option) {
                        return;
                    }
                    selectClient({
                        id: option.value,
                        name: option.label,
                    });
                }}
                styles={selectStyles}
            />
        </div>
    ) : null;
};

export default ClientSelect;
